// extracted by mini-css-extract-plugin
export default {"wrap":"MusicBuskAlbum_wrap__EFxsc","iframe":"MusicBuskAlbum_iframe__0-uV+"};